import styled from '@emotion/styled';

import { FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import { TitleAccent1 } from '@zola/zola-ui/src/typography/Headings';

export const PLPHeaderContainer = styled.div`
  margin-top: 48px;
  margin-bottom: 68px;
  text-align: center;
`;

export const PLPTitleAccent1 = styled(TitleAccent1)`
  margin-bottom: ${SPACING.S24};
`;

export const SubText = styled.p`
  max-width: 564px;
  width: 100%;
  margin: 0 auto;
  font-size: ${FONT.SIZE.REGULAR};
  ${MEDIA_QUERY_V2.MOBILE} {
    font-size: ${FONT.SIZE.SMALL};
  }
`;
